<div class="dx-field">
  <div class="dx-field-label" style="overflow: visible">
    {{ 'Feld-Auswahl' | translate }}
  </div>
  <div class="dx-field-value">
    <dx-select-box
        [dataSource]="types"
        [(value)]="selectedType"
        displayExpr="translated"
        valueExpr="value"
    />
  </div>
</div>
